/*
 * @Author: songpan
 * @Date: 2022-03-03 10:30:07
 * @LastEditTime: 2022-10-09 15:42:13
 * @LastEditors: songpan
 * @Description: 移动端页面适配
 */
!(function (n) {
  const e = n.document,
    t = e.documentElement,
    i = 750,
    d = i / 100,
    o = 'orientationchange' in n ? 'orientationchange' : 'resize',
    a = function () {
      let n = t.clientWidth || 320;
      n > 750 && (n = 750);
      t.style.fontSize = n / d + 'px';
    };
  e.addEventListener && (n.addEventListener(o, a, !1), e.addEventListener('DOMContentLoaded', a, !1));
})(window);
